import React from 'react';
import PropTypes from 'prop-types';
import 'lazysizes';

const OptimizedImage = props => {
  const { className, imageUrl } = props;

  let imgUrl;

  // This is because not all of PS is updated yet
  try {
    imgUrl = JSON.parse(imageUrl);
    if (!imgUrl.alt) {
      imgUrl.alt = '';
    }
  } catch (e) {
    imgUrl = {
      small: imageUrl,
      medium: imageUrl,
      alt: ''
    };
  }

  return (
    <picture>
      <source data-srcset={imgUrl.medium} media="(min-width: 768px)" />
      <source data-srcset={`${imgUrl.small} 0.5x`} media="(min-width: 480px)" />
      <source data-srcset={`${imgUrl.small} 0.5x`} media="(min-width: 0px)" />
      <img
        data-src={imgUrl.small}
        className={`${className} lazyload`}
        alt={imgUrl.alt}
      />
    </picture>
  );
};

OptimizedImage.propTypes = {
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string
};
export default OptimizedImage;
